import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// === CLIENTES ===
export const ordenesClientesAPI = {
    getAll: (search) => api.get('/api/ordenes/clientes', { params: { search } }),
    getById: (id) => api.get(`/api/ordenes/clientes/${id}`),
    create: (data) => api.post('/api/ordenes/clientes', data),
    update: (id, data) => api.put(`/api/ordenes/clientes/${id}`, data),
    delete: (id) => api.delete(`/api/ordenes/clientes/${id}`),
    deleteBulk: (ids) => api.post('/api/ordenes/clientes/eliminar-masivo', { ids }),
};

// === VEHÍCULOS ===
export const ordenesVehiculosAPI = {
    getAll: (params) => api.get('/api/ordenes/vehiculos', { params }),
    getById: (id) => api.get(`/api/ordenes/vehiculos/${id}`),
    create: (data) => api.post('/api/ordenes/vehiculos', data),
    update: (id, data) => api.put(`/api/ordenes/vehiculos/${id}`, data),
    delete: (id) => api.delete(`/api/ordenes/vehiculos/${id}`),
    deleteBulk: (ids) => api.post('/api/ordenes/vehiculos/eliminar-masivo', { ids }),
};

// === ÓRDENES ===
export const ordenesServicioAPI = {
    getAll: (params) => api.get('/api/ordenes/ordenes', { params }),
    getById: (id) => api.get(`/api/ordenes/ordenes/${id}`),
    create: (data) => api.post('/api/ordenes/ordenes', data),
    update: (id, data) => api.put(`/api/ordenes/ordenes/${id}`, data),
    delete: (id) => api.delete(`/api/ordenes/ordenes/${id}`),
    tomar: (id, data) => api.post(`/api/ordenes/ordenes/${id}/tomar`, data),
    completar: (id, data) => api.post(`/api/ordenes/ordenes/${id}/completar`, data),
    facturar: (id, data) => api.post(`/api/ordenes/ordenes/${id}/facturar`, data),
    cancelar: (id, motivo) => api.post(`/api/ordenes/ordenes/${id}/cancelar`, null, { params: { motivo } }),
    enviarCliente: (id, enviarEmail = false) => api.post(`/api/ordenes/ordenes/${id}/enviar-cliente`, null, { params: { enviar_email: enviarEmail } }),
    enviarEmailCliente: (id) => api.post(`/api/ordenes/ordenes/${id}/enviar-cliente`, null, { params: { enviar_email: true } }),
    validarCliente: (id, aprobado, observaciones) => api.post(`/api/ordenes/ordenes/${id}/validar-cliente`, null, { params: { aprobado, observaciones } }),
};

// === INVENTARIO ===
export const ordenesInventarioAPI = {
    getAll: (params) => api.get('/api/ordenes/inventario', { params }),
    getResumen: () => api.get('/api/ordenes/inventario/resumen'),
    create: (data) => api.post('/api/ordenes/inventario', data),
    update: (id, data) => api.put(`/api/ordenes/inventario/${id}`, data),
    delete: (id) => api.delete(`/api/ordenes/inventario/${id}`),
    deleteBulk: (ids) => api.post('/api/ordenes/inventario/eliminar-masivo', { ids }),
    updateBulk: (ids, marca, modelo) => api.post('/api/ordenes/inventario/actualizar-masivo', { ids, marca, modelo }),
};

// === DISPOSITIVOS INSTALADOS ===
export const ordenesDispositivosAPI = {
    getAll: (params) => api.get('/api/ordenes/dispositivos-instalados', { params }),
    delete: (id) => api.delete(`/api/ordenes/dispositivos-instalados/${id}`),
    deleteBulk: (ids) => api.post('/api/ordenes/dispositivos-instalados/eliminar-masivo', { ids }),
};

// === KPIs y ESTADÍSTICAS ===
export const ordenesKPIsAPI = {
    get: () => api.get('/api/ordenes/kpis'),
    porTipoServicio: () => api.get('/api/ordenes/estadisticas/por-tipo-servicio'),
    porTecnico: () => api.get('/api/ordenes/estadisticas/por-tecnico'),
    tendenciaMensual: () => api.get('/api/ordenes/estadisticas/tendencia-mensual'),
};

// === CONFIGURACIÓN ===
export const ordenesConfigAPI = {
    getCampos: (entidad) => api.get('/api/ordenes/configuracion/campos', { params: { entidad } }),
    createCampo: (data) => api.post('/api/ordenes/configuracion/campos', data),
    deleteCampo: (id) => api.delete(`/api/ordenes/configuracion/campos/${id}`),
    getPermisosDisponibles: () => api.get('/api/ordenes/permisos-disponibles'),
    getRoles: () => api.get('/api/ordenes/roles'),
    createRol: (data) => api.post('/api/ordenes/roles', data),
    getUsuarios: () => api.get('/api/ordenes/usuarios'),
    asignarRol: (usuarioId, rolCodigo) => api.post(`/api/ordenes/usuarios/${usuarioId}/asignar-rol`, null, { params: { rol_codigo: rolCodigo } }),
    quitarRol: (usuarioId) => api.delete(`/api/ordenes/usuarios/${usuarioId}/rol`),
};

// === CATÁLOGOS ===
export const ordenesCatalogosAPI = {
    getTiposServicio: () => api.get('/api/ordenes/tipos-servicio'),
    getTiposDispositivo: () => api.get('/api/ordenes/tipos-dispositivo'),
};

// === IMPORTACIÓN ===
export const ordenesImportacionAPI = {
    descargarPlantilla: (tipo) => api.get(`/api/ordenes/importacion/plantilla/${tipo}`, { responseType: 'blob' }),
    importarClientes: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/api/ordenes/importacion/clientes', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    importarVehiculos: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/api/ordenes/importacion/vehiculos', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    importarInventario: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/api/ordenes/importacion/inventario', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
};

// === DOCUMENTOS ===
export const ordenesDocumentosAPI = {
    getByOrden: (ordenId) => api.get(`/api/ordenes/ordenes/${ordenId}/documentos`),
    upload: (ordenId, file, tipoDocumento) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post(`/api/ordenes/ordenes/${ordenId}/documentos`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params: { tipo_documento: tipoDocumento }
        });
    },
    delete: (documentoId) => api.delete(`/api/ordenes/documentos/${documentoId}`),
};

// === NOTIFICACIONES ===
export const ordenesNotificacionesAPI = {
    getConfig: () => api.get('/api/ordenes/notificaciones/config'),
    updateConfig: (config) => api.post('/api/ordenes/notificaciones/config', config),
};

// === DATOS DEMO ===
export const ordenesSeedAPI = {
    seedDemo: () => api.post('/api/ordenes/seed-demo'),
};

export default api;
